export const emojiUrl = ''
export const emojiMap = {         // 根据[呲牙]可匹配的路径地址
    '[微笑]': 'https://imgcache.qq.com/open/qcloud/tim/assets/emoji/emoji_49@2x.png',
    '[呲牙]': 'https://imgcache.qq.com/open/qcloud/tim/assets/emoji/emoji_141@2x.png',
    '[流汗]': 'https://imgcache.qq.com/open/qcloud/tim/assets/emoji/emoji_75@2x.png',
    '[偷笑]': 'https://imgcache.qq.com/open/qcloud/tim/assets/emoji/emoji_7@2x.png',
    '[炸弹]': 'https://imgcache.qq.com/open/qcloud/tim/assets/emoji/emoji_79@2x.png'
}